import React from "react";
import {authConfig} from "../../conf/Auth";
import AccountActivatePage from "./AccountActivatePage";

class SelfAccountActivatePage extends React.Component {
  render() {
    return (
      <AccountActivatePage
        type={"forgotPassword"}
        applicationId={authConfig.appName}
        account={this.props.account}
        {...this.props}
      />
    );
  }
}

export default SelfAccountActivatePage;
